module.exports = __webpack_public_path__ + "static/media/flag-turkiye.acadac2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/LanguageFlag/LanguageFlagIcons/flag-turkiye.svg
// module id = 1136
// module chunks = 1